<template>
  <div :class="{'wiki_home':true, 'wiki_wrap': listdata.isFull}">
    <span v-wechat-title="dataInfo.title" />
    <GCLOADING :is-show="isLoading" />
    <GCHEADER v-if="!tipShow" des="wikiview" :status="listdata.previews" :param="query.id" :webapp-link="webappLink" />
    <GCGUIDE :down-show="guideShow" />
    <ShareInfo :share-info="shareData" />
    <div v-if="dataInfo.images&&dataInfo.images.length>0" class="wiki_swiper">
      <template v-if="!isLoading">
        <Swipe :autoplay="3000" class="swiper" :show-indicators="dataInfo.images.length" indicator-color="#333">
          <SwipeItem v-for="(img, i) in dataInfo.images" :key="i">
            <VanImage :src="img" fit="cover" alt="百科图" class="wiki_img" />
          </SwipeItem>
        </Swipe>
      </template>
    </div>
    <div class="wiki_verify">
      <div class="wiki_left">
        <img class="wiki_lfimg" src="https://img.mingchu.co/Nuploads/headpic/6412bcb7743a8.png" alt="">
        <span class="wiki_lfspan">{{ $t('wiki.text') }} </span>
      </div>
      <div class="wiki_right" @click="wikiclick">
        <img class="wiki_rgtimg" src="https://img.mingchu.co/Nuploads/headpic/6412bccccb2b0.png" alt="">
        <span class="wiki_rgtspan">{{ $t('wiki.text1') }}</span>
      </div>
    </div>
    <div class="wiki_information">
      <div class="wiki_name">{{ dataInfo.title }}</div>
      <div class="wiki_list">
        <div v-for="(item, p) in dataInfo.intro_keyword" :key="p" class="wiki_li">
          <div class="content_label">{{ item.label }}：</div>
          <div class="content_txt">
            <div v-for="(text,t) in item.value" :key="t" class="content_right">{{ text }} </div>
          </div>
        </div>
      </div>
      <div class="wiki_intro" style="word-break:break-all" v-html="dataInfo.intro" />
    </div>
    <template v-if="dataInfo.content">
      <div class="thread" />
      <Markdown :content="dataInfo.content" />
    </template>
    <div v-if="dataInfo.reference&&dataInfo.reference.length>0" class="thread" />
    <div v-if="dataInfo.reference&&dataInfo.reference.length>0" class="references">
      <div class="ref_title">{{ $t('wiki.text3') }} </div>
      <div v-for="(text,t) in dataInfo.reference" :key="t" class="ref_list"><div>[{{ t+1 }}]</div>{{ text.title }}[{{ $t('wiki.text10') }}{{ text.created_at }}]</div>
    </div>
    <div v-if="dataInfo.contribution&&dataInfo.contribution.length>0" class="thread" />
    <div v-if="dataInfo.contribution&&dataInfo.contribution.length>0" class="userList">
      <div class="ref_title">{{ $t('wiki.text4') }} </div>
      <div v-if="dataInfo.contribution&&dataInfo.contribution.length>2" class="user_cent">
        <div v-if="listdata.lang_id!=3" class="quantity">{{ $t('wiki.text5') }}{{ dataInfo.contribution.length }}{{ $t('wiki.text9') }} </div>
        <div v-else class="quantity">{{ dataInfo.contribution.length }}<span style="margin-left:3px">{{ $t('wiki.text5') }}</span> </div>
        <div class="entry">{{ $t('wiki.text6') }} </div>
        <div class="sculptureList" @click="onSheet()">
          <div v-for="(text,t) in dataInfo.contribution" :key="t" class="sculpture">
            <img v-if="t<=4" class="sculptureimg" :src="text.usr_pic" alt="">
          </div>
          <div class="userright"><img class="rightimg" src="https://img.mingchu.co/Nuploads/headpic/6412bd487507b.png" alt=""></div>
        </div>
      </div>
      <div v-else class="contributor">
        <div v-for="(item,t) in dataInfo.contribution" :key="t" class="contributorLi" @click="goPath('userview',item.uid)">
          <div class="li_left">
            <img class="li_tou" :src="item.usr_pic" alt="">
            <img v-if="item.auth_pic" class="li_auth" :src="item.auth_pic" alt="">
          </div>
          <div class="li_right">
            <div class="li_rht_name">{{ item.nick_name }}</div>
            <div class="li_rht_bot">{{ item.unit_duty }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="dataInfo.recommends&&dataInfo.recommends.length>0" class="signFood">
      <div class="sign_top">
        <div class="sign_title">{{ $t('wiki.text7') }} </div>
        <div class="sign_more" @click="foodList()"><div><div>{{ $t('wiki.text8') }} </div><img src="https://greatchefupload.oss-accelerate.aliyuncs.com/Nuploads/headpic/1672824507000763781.png" alt=""></div></div>
      </div>
      <div class="foodList">
        <div v-for="(item,index) in dataInfo.recommends" :key="index" class="foodLast" @click="goPath('foodview',item.id)">
          <SingleFood
            :data-info="item"
            :iszan="false"
          />
        </div>
      </div>
    </div>
    <div :class="{'wikifoot':true, 'wikifoot_wrap': listdata.isFull}">
      <div class="replenish">
        <div class="replenish_left" @click="goPath('wikiview',dataInfo.id,1)">
          <img class="re_lf_img" src="https://img.mingchu.co/Nuploads/headpic/641d7943c9584.png" alt="">
          <div class="re_text">{{ $t('wiki.text2') }}</div>
        </div>
        <div class="replenish_right">
          <div class="replenish_li" @click="goPath('wikiview',dataInfo.id,2)">
            <img class="re_rht_img" src="https://img.mingchu.co/Nuploads/headpic/6412bdc3af1aa.png" alt="">
            <div class="re_rht_text">{{ dataInfo.zan }}</div>
          </div>
          <div class="replenish_li">
            <img class="re_rht_img" src="https://img.mingchu.co/Nuploads/headpic/6412be1abf41c.png" alt="" @click="goPath('wikiview',dataInfo.id,3)">
            <div class="re_rht_text">{{ dataInfo.like }}</div>
          </div>
        </div>
      </div>
      <view class="footHeight" />
    </div>
    <van-action-sheet
      :show="isShow"
      :title="$t('wiki.text4') "
      @cancel="ruleCancel"
    >
      <div class="sheet_content">
        <div class="cont_content">
          <div class="contributor">
            <div v-for="(item,t) in dataInfo.contribution" :key="t" class="contributorLi content_li" @click="goPath('userview',item.uid)">
              <div class="li_left">
                <img class="li_tou" :src="item.usr_pic" alt="">
                <img v-if="item.auth_pic" class="li_auth" :src="item.auth_pic" alt="">
              </div>
              <div class="li_right">
                <div class="li_rht_name">{{ item.nick_name }}</div>
                <div class="li_rht_bot">{{ item.unit_duty }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script setup>
import config from '@/config/config'
import { isGteatChefbrowser, platformType, fullScreen, isWechat, isAndroid } from '@/utils'
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { Swipe, SwipeItem, Image as VanImage, Dialog, Toast, ActionSheet as VanActionSheet } from 'vant'
import { ajaxHttp } from '@/api/api'
import { superLink } from '@/utils'
import ShareInfo from '@/components/shareInfo'
import GCHEADER from '@/components/gc-header'
import GCGUIDE from '@/components/gc-guide'
import GCLOADING from '@/components/gc-loading'
import SingleFood from '@/components/singleFood'
import Markdown from '@/components/Markdown.vue'

const router = useRouter()
const dialogShow = ref(false)
const isLoading = ref(true)
const guideShow = ref(false) // 默认浏览器打开引导框
const isShow = ref(false)
const tipShow = ref(isGteatChefbrowser()) // 是否展示打开app的tabbar
// const isFull = ref(false)
const query = ref(router.currentRoute.value.query) // 页面id
const webappLink = ref(`${config.webapplink}/wikiview?id=${query.value.id}`) // 打开的H5链接
let dataInfo = reactive({
  title: ''
})
const listdata = reactive({
  previews: 1,
  lang_id: '1',
  isFull: false
})
const shareData = reactive({ // 分享数据
  share_title: '',
  share_des: '',
  share_link: '',
  share_img: ''
})
onMounted(() => {
  if (fullScreen() && !isAndroid()) {
    listdata.isFull = true
  }
})
const getDataInfo = () => { // 获取详情数据
  if (query.value.preview) {
    listdata.previews = 0
  } else {
    listdata.previews = 1
  }
  if (query.value.lang_id) {
    listdata.lang_id = query.value.lang_id
  }
  ajaxHttp.$get(`/api/wiki/${query.value.id}`, { wiki_lang_id: query.value.lang_id }).then(res => {
    if (res.code === 1) {
      res.data.intro = res.data.intro.replace(/\[\d+]/g, function(x) {
        return '<span style="color:#999999">' + x + '</span>'
      })
      dataInfo = { ...res.data }
      dataInfo.goods_pic = res.data.goods_pic
      shareData.share_title = dataInfo.share.share_title
      shareData.share_desc = dataInfo.share.share_desc
      shareData.share_link = dataInfo.share.share_link
      if (dataInfo.share.share_img) {
        shareData.share_img = dataInfo.share.share_img
      } else {
        shareData.share_img = 'https://img.mingchu.co/Nuploads/headpic/641828d8ee0c0.png'
      }
      sensors.track('WikiView', {
        PlatformType: platformType(),
        wiki_id: query.value.id,
        wiki_title: dataInfo.title,
        position: 'wiki'
      })
      isLoading.value = false
    } else {
      Toast(res.message)
    }
  })
}
getDataInfo()
const ruleCancel = () => {
  isShow.value = false
}
const foodList = () => {
  sensors.track('WikiViewButtonClick', {
    PlatformType: platformType(),
    wiki_id: query.value.id,
    wiki_title: dataInfo.title,
    position: 'wiki',
    button_type: '相关推荐更多'
  })
  router.push({ path: '/wikilist', query: { id: query.value.id, lang_id: query.value.lang_id }})
}
const onSheet = () => {
  sensors.track('WikiViewButtonClick', {
    PlatformType: platformType(),
    wiki_id: query.value.id,
    wiki_title: dataInfo.title,
    position: 'wiki',
    button_type: '贡献者更多'
  })
  isShow.value = true
}
const goPath = (_des, _skuid, type = false) => {
  if (type === 1) {
    sensors.track('WikiViewButtonClick', {
      PlatformType: platformType(),
      wiki_id: query.value.id,
      wiki_title: dataInfo.title,
      position: 'wiki',
      button_type: '我要补充'
    })
  } else if (type === 2) {
    sensors.track('WikiViewButtonClick', {
      PlatformType: platformType(),
      wiki_id: query.value.id,
      wiki_title: dataInfo.title,
      position: 'wiki',
      button_type: '点赞'
    })
  } else if (type === 3) {
    sensors.track('WikiViewButtonClick', {
      PlatformType: platformType(),
      wiki_id: query.value.id,
      wiki_title: dataInfo.title,
      position: 'wiki',
      button_type: '收藏'
    })
  } else {
    console.log(type)
  }
  if (isAndroid() && isWechat()) {
    guideShow.value = true
    return false
  }
  const data = `{
        "des": "${_des}", 
        "skuid": "${_skuid}",
        "link": "${config.webapplink}/${_des}?id=${_skuid}"
      }`
  return superLink(data)
}
const wikiclick = () => {
  location = dataInfo.audit_desc_link
}
</script>
<style scoped>
.sculpture:nth-child(2){margin-left:-6px}
.sculpture:nth-child(3){margin-left:-6px}
.sculpture:nth-child(4){margin-left:-6px}
.sculpture:nth-child(5){margin-left:-6px}

.sheet_content{height: 472px;border-top: 0.5px solid #E5E5E5;overflow: hidden;}
.sheet_content{padding-left: 16px;}
.cont_content{height:440px;overflow-y: scroll;}
.content_li{height: 88px !important;}
.wiki_home :deep(.van-action-sheet__header){font-size: 16px !important; color: #333 !important;font-weight: bold !important;width: 315px;margin-left:30px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.wiki_home :deep(.van-action-sheet__close){color: #999999 !important;font-size: 14px !important;font-weight: bold !important;}
.wiki_home{width: 100%;height: 100%;overflow: hidden;padding-bottom: 104px;}
.wiki_wrap{padding-bottom: 138px;}
.swiper{ width: 375px; height: 240px; }
.wiki_swiper{width: 375px; height: 240px;}
.wiki_img{ width: 375px; height: 240px; }
.wiki_home :deep(.van-swipe__indicator){width: 4px;height: 4px;background: #E5E5E5 !important;}
.wiki_home :deep(.van-swipe__indicator--active){background-color: #333333 !important;}
.wiki_verify{width: 375px;height: 28px;display: flex;box-sizing: border-box;justify-content: space-between;background: #F7F4F1;}
.wiki_left{margin-left:16px;display: flex;align-items: center;}
.wiki_lfimg{width: 14px;height: 14px;}
.wiki_lfspan{font-size: 12px;color: #C9A128;margin-left: 2px;}
.wiki_right{margin-right:16px;background:  #FAF5E6;;height:19px;margin-top: 4.5px;display: flex;align-items: center;}
.wiki_rgtimg{width: 11px;height: 11px;}
.wiki_rgtspan{font-size: 10px;margin-left: 2px;color: #C9A128;padding-right: 6px;}
.wiki_information{padding: 16px 16px 12px 16px;}
.wiki_name{border-bottom: 0.5px solid #E5E5E5;color: #333333;font-size: 24px;font-weight: bold;line-height: 34px;padding-bottom: 5px;}
.wiki_list{padding-bottom: 12px;}
.wiki_li{display: flex;padding:8px 0;border-bottom: 0.5px solid #E5E5E5;}
.content_label{color: #333333;font-size: 14px;font-weight: bold;}
.content_txt{color: #999999;font-size: 14px;flex: 1;display: inline-flex;flex-wrap: wrap;}
.wiki_intro{color: #333333;font-size: 16px;line-height: 24px;}
.wiki_intro span{color: #999999;line-height: 22px;}
.thread{background: #F9F8F8;height: 8px;}
.references{padding: 16px;}
.ref_title{color: #333333;font-weight: bold;font-size: 18px;}
.ref_list{color: #999999;font-size: 12px;line-height: 14px;display: flex;margin-top: 6px;}
.userList{padding: 24px 16px 0 16px;}
.user_cent{text-align: center;padding: 24px 0 32px 0 ;}
.quantity{color: #666666;font-size: 14px;line-height: 20px;}
.entry{color: #999999;font-size: 12px;line-height: 17px;margin-top: 4px;}
.sculptureList{display: flex;justify-content: center;margin-top:16px;}
.sculptureimg{width: 48px;height: 48px;border: 1px solid #E5E5E5;border-radius: 50px;position:reactive;left:-6px;}
.userright{width: 24px;height: 24px;margin-left:5px;margin-top: 12px;}
.signFood{background: linear-gradient(180deg, #FAF5E6 0%, rgba(250, 245, 230, 0) 100%);}
.sign_top{display: flex;justify-content: space-between;padding-top: 16px;}
.sign_title{font-weight: bold;font-size: 18px;line-height: 25px;color: #333333;padding-left: 16px;}
.sign_more{height: 25px;padding-right: 16px;}
.sign_more div{color: #C99700;font-size: 14px;line-height:25px;display: flex;}
.sign_more div img{width: 16px;height: 16px;position: relative;top: 3.5px;}
.foodList{width: 100%;padding-left:16px;margin-top: 16px;display: flex;overflow-x: scroll;}
.foodList::-webkit-scrollbar {display:none;}
.wikifoot{width: 100%;position: fixed;bottom: -1px;background: #FFFFFF;border-top: 0.5px solid #E5E5E5;height:64px;}
.wikifoot_wrap{height:98px;}
.replenish{padding:16px;display: flex;justify-content: space-between;}
.replenish_left{display: flex;border-radius:48px;height: 32px;border: 1px solid #C99700;padding:0 16px;line-height: 32px;}
.re_lf_img{width: 16px;height: 16px;margin: 8px 8px 0 0;}
.re_text{color: #C99700;font-size: 14px;}
.replenish_right{display: flex;color: #999999;font-size: 14px;}
.replenish_li{display: flex;margin-left: 16px;align-items: center;}
.re_rht_img{width: 32px;height: 32px;margin-right: 2px;}
.contributorLi{height:72px;display: flex;border-bottom: 0.5px solid #E5E5E5;align-items: center;}
.li_left{width: 48px;height: 48px;position: relative;}
.li_tou{border: 1px solid #E5E5E5;border-radius: 50%;width: 48px;height: 48px;}
.li_auth{width: 12px;height:12px;border: 0.5px solid #FFFFFF;position: absolute;bottom: 0;right: 0px;border-radius: 50px;}
.li_right{margin-left: 16px;}
.li_rht_name{color: #333333;font-size: 16px;font-weight: bold;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;}
.li_rht_bot{display: flex;color: #999999;font-size: 12px;    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;}
.contributorLi:nth-last-child(1){border-bottom: none;}
.li_rht_xian{margin:0 6px;}
.footHeight{height: 30px;}
.foodLast:last-child{padding-right:18px;}
</style>

